import React from "react";
import { message } from "antd";
import { FunnelPlotOutlined } from "@ant-design/icons";
import UploadStatusModal from "./upload-status-modal";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import TableComponent from "./table";
import axios from "axios";
import { openNotification } from "../../../shared/notification";
import { post } from "../../../services";
import FilterModal from "./filter-modal";

const Faq = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchedFilter, setSearchFilter] = useState("");
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [properties, setProperties] = useState([]);
  const [loader, setLoader] = useState(true);
  const [selectedRecord, setSelectedRecord] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);

  //method for API call
  const getPropertyHandler = (currentPage) => {
    setCurrentPage(currentPage);

    setLoader(true);
    // CURRENT PAGE
    const pageSize = 50;
    const start = (currentPage - 1) * pageSize;
    // Remove ?find=
    const cleaned = location.search.replace("?find=&", "");

    // Convert to URLSearchParams
    const params = new URLSearchParams(cleaned);
    const filterParams = [];
    params.forEach((value, key) => {
      filterParams.push(`filter[${key}]=${value}`);
    });
    // Final result
    const finalQuery = filterParams.join("&");
    const filter = location.search ? finalQuery : "";
    const search = location.search ? start + "&" + finalQuery : start;
    setSearchFilter(filter);
    // API CALL
    axios
      .get(
        `https://empireinfratech.bitrix24.com/rest/8/0qi2je7ccei3r5sb/crm.item.list?entityTypeId=1058&start=${search}`
      )
      .then((response) => {
        setProperties({
          properties: response?.data?.result?.items,
          totalPropertys: response?.data?.total,
        });
        setLoader(false);
      })
      .catch((error) => {
        message.error("Error", error?.response?.data?.message);
        setLoader(false);
      });
  };

  //  API for Faq
  useEffect(() => {
    getPropertyHandler(1);
    // eslint-disable-next-line
  }, [limit, location.search]);

  const cancel = (e) => {
    console.log(e);
  };

  // confirm handler
  const confirm = (data) => {
    setSelectedRecord(data?.id);
    axios
      .post(
        `https://empireinfratech.bitrix24.com/rest/8/0qi2je7ccei3r5sb/crm.item.delete?entityTypeId=1058&&id=${data?.id}`
      )
      .then(() => {
        // to delete locally from our database
        const remaingRecords = properties?.properties?.filter(
          (item) => item?.id !== data?.id
        );
        setProperties({ ...properties, properties: remaingRecords });
        // success message
        message.success("Record deleted Successfully");
        setSelectedRecord(false);
      })
      .catch((error) => {
        message.error("Error", error?.response?.data?.message);
        setSelectedRecord(false);
      });
  };

  // rowSelection
  const rowSelection = {
    selectedRowKeys,
    hideSelectAll: true,
    onSelect: (record, selected) => {
      if (!selected) {
        const remaingRecords = selectedRowKeys?.filter(
          (item) => item !== record.id
        );
        setSelectedRowKeys(remaingRecords);
      } else {
        const newSelectedKeys = [...selectedRowKeys, record.id];
        setSelectedRowKeys(newSelectedKeys);
      }
    },
  };

  const reverseMapStatus = (status) => {
    switch (status) {
      case "off_plan":
        return "OFF_PLAN";
      case "completed_primary":
        return "SALE";
      case "off_plan_primary":
        return "SALE_OFF_PLAN";
      case "completed":
        return "SALE";
      default:
        return status;
    }
  };

  // onSubmit handler to save
  const onSubmit = (values) => {
    setIsStatusModalOpen(true);
    setSelectedRecord(values?.id);
    // payload
    const payloads = [
      {
        title: values?.ufCrm18TitleEn || "",
        saleOrRentprice: values?.ufCrm18Price || "",
        type: values?.ufCrm18PropertyType || "",
        status: reverseMapStatus(values?.ufCrm18ProjectStatus) || "",
        publishing_status: values?.ufCrm18Status || "",
        offering_type: values?.ufCrm18OfferingType || "",
        finishing_type: values?.ufCrm18Furnished || "",
        uae_emirate: values?.ufCrm18UaeEmirate || "",
        bedrooms: values?.ufCrm18Bedroom || "",
        bathrooms: values?.ufCrm18Bathroom || "",
        garagesOrParkingSpaces: values?.ufCrm18Parking || "",
        area: values?.ufCrm18Size || "",
        developer: values?.ufCrm18Developers || "",
        referenceNumber: values?.ufCrm18ReferenceNumber || "",
        description: values?.ufCrm18DescriptionEn
          ? `<p>${values.ufCrm18DescriptionEn}</p>`
          : "",
        address: values?.ufCrm18Location || "",
        images: (values?.ufCrm18PhotoLinks || []).map((url) => ({
          url,
          altTitle: "",
          metaData: {
            title: "",
            description: "",
            keywords: "",
          },
        })),
        longitude: parseFloat(values?.ufCrm18Geopoints?.split(",")[0]) || 0,
        latitude: parseFloat(values?.ufCrm18Geopoints?.split(",")[1]) || 0,
        areaPostfix: values?.areaPostfix || "",
        handoverDate: values?.handoverDate || "",
        meta_title: [],
        meta_description: [],
        meta_keyword: [],
        agentInformationDisplay: values?.agentInformationDisplay || "None",
        acceptTermsAndConditions: true,
        videos: [],
        floorPlans: [],
        additionalDetails: [],
        features: values?.ufCrm18Amenities || [],
        importedFromCrm: true,
      },
    ];
    post(`/property/bulkAdd`, { properties: payloads })
      .then(() => {
        openNotification("Success", "Property created successfully");
        setIsStatusModalOpen(false);
        setSelectedRecord(false);
      })
      .catch((error) => {
        setIsStatusModalOpen(false);
        openNotification("Error", error?.response?.data?.message);
        setSelectedRecord(false);
      });
  };

  // filterData
  const handleFilter = (values) => {
    const filterParams = Object.entries(values)
      .filter(([_, value]) => value && value !== "")
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");
    const queryString = `&${filterParams}`;
    navigate(`/crm-properties?find=${queryString}`);
    setIsFilterModalOpen(false);
  };
  return (
    <React.Fragment>
      <div className="header mb-5">
        <h3>Total Properties: {properties?.totalPropertys}</h3>
        <div className="d-flex">
          <button
            className="cursor-pointer "
            onClick={() => setIsFilterModalOpen(true)}
          >
            <span className="mx-5">
              <FunnelPlotOutlined />
            </span>
            Filter
          </button>
          {searchedFilter && (
            <button
              className="cursor-pointer ml-5 filter-clear-button"
              onClick={() => navigate(`/crm-properties`)}
            >
              Clear
            </button>
          )}
        </div>
      </div>
      {/* Modal */}
      <UploadStatusModal isStatusModalOpen={isStatusModalOpen} />
      {/* Modal */}
      <FilterModal
        isFilterModalOpen={isFilterModalOpen}
        setIsFilterModalOpen={setIsFilterModalOpen}
        handleFilter={handleFilter}
      />
      {/* Table */}
      <TableComponent
        properties={properties}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        loader={loader}
        selectedRecord={selectedRecord}
        navigate={navigate}
        getPropertyHandler={getPropertyHandler}
        cancel={cancel}
        limit={limit}
        confirm={confirm}
        setLimit={setLimit}
        rowSelection={rowSelection}
        onSubmit={onSubmit}
      />
    </React.Fragment>
  );
};
export default Faq;
